// © Microsoft Corporation. All rights reserved.

/// <summary>Creates a function defined as "extend" that functions similiar to jQuery's extend function.</summary>

function isArray(arr) {
    // Check support for isArray
    if (Array.isArray) {
        return Array.isArray(arr);
    } else {
        return Object.prototype.toString.call(arr).toLowerCase() === "[object array]";
    }
}

function extend(...args: any[]) {
    var target = args[0] || {};
    var ndx = 1;
    var key;
    var obj;
    var isRecursive;
    var src;

    if (typeof target == "boolean" || typeof target == "number") {
        isRecursive = !!target;
        target = args[1];
        ndx = 2;
    }
    for (; ndx < args.length; ndx++) {
        obj = args[ndx];
        for (key in obj) {
            if (obj[key] !== undefined && obj[key] !== null) {
                if (isRecursive && typeof obj[key] == "object") {
                    src = target[key];
                    if (typeof src != "object") {
                        if (isArray(obj[key])) {
                            src = [];
                        } else {
                            src = {};
                        }
                    }

                    extend(true, src, obj[key]);
                    target[key] = src;
                } else {
                    target[key] = obj[key];
                }
            }
        }
    }
    return target;
};

export default extend;
